"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "1",
  question: "What fire protection services does A+ Fire provide?",
  answer: "A+ Fire offers comprehensive fire protection services including fire extinguisher inspections, recharging and replacements, Ansul hood and kitchen suppression systems, sprinkler testing and inspections, and 24/7 emergency response for commercial kitchens, residential properties, and local businesses across Northern Virginia."
}, {
  id: "2",
  question: "Why should I choose A+ Fire over other fire protection companies?",
  answer: "A+ Fire is family-owned and operated by Mike, who personally handles all service calls. You'll speak directly with the owner-technician, not a secretary or call center. We provide fast response times, honest work without upselling, and all our technicians are certified and insured."
}, {
  id: "3",
  question: "What areas does A+ Fire serve?",
  answer: "A+ Fire serves all of Northern Virginia, including Arlington, Fairfax, Alexandria, and surrounding areas. If you're located in Northern Virginia and need fire protection services, call Mike directly to discuss your needs."
}, {
  id: "4",
  question: "How do I schedule a fire safety inspection?",
  answer: "Scheduling is easy—simply call Mike directly at Call Mike or email us at aplusfire@yahoo.com. We offer appointments by request and are available for emergency service calls 24/7."
}, {
  id: "5",
  question: "Are your fire protection services certified and insured?",
  answer: "Yes, A+ Fire is fully certified and insured. Mike and his team meet all industry standards and certifications for fire protection services, giving you peace of mind that your property is in safe, professional hands."
}, {
  id: "6",
  question: "What is the difference between fire extinguisher recharging and replacement?",
  answer: "Fire extinguisher recharging involves refilling an extinguisher that has been partially or fully discharged. Replacement is necessary when an extinguisher is damaged, outdated, or has failed inspection. Mike will assess your equipment and recommend the most cost-effective solution."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div ref={ref} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground-light text-center mb-3 font-display">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-center mb-10">
            Get answers to common questions about our fire protection services
          </p>

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="bg-primary border-none rounded-md overflow-hidden shadow-soft hover:shadow-medium transition-shadow duration-[var(--duration-medium)]">
                <AccordionTrigger className="px-5 py-4 text-foreground-primary font-semibold text-left hover:no-underline hover:bg-primary-hover transition-colors duration-[var(--duration-fast)]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-5 pb-4 pt-0 bg-light-background text-foreground-light">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}